
import moment from 'moment';
import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCalendarPeriodFilter } from 'src/app/core/models/period-selector/newCalendarPeriodFilter';
import { NewCalendarPeriodSelectorItem } from './base/new-calendar-period-selector-item';

export class YearPeriodSelectorItem extends NewCalendarPeriodSelectorItem {
    interval = NewPeriodSelectorInterval.Year;
    hasNavigation = true;

    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        let endDate: Date;
        const currentDate = moment().startOf('day').toDate();
        endDate = currentDate;
        const firstDayOfTheYear = moment(endDate).startOf('year').toDate();
        const startDate = moment(firstDayOfTheYear).startOf('day').toDate();
        endDate = moment(endDate).endOf('day').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = startDate;
        periodFilter.endDate = endDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Year;

        return periodFilter;
    }

    getPreviousPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        let newEndDate = moment(currentFilter.startDate).add(-1,'day').startOf('day').toDate();
        const newStartDate = moment(newEndDate).startOf('year').toDate();
        newEndDate = moment(newEndDate).endOf('year').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Year;

        return periodFilter;
    }

    getNextPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        const newStartDate = moment(currentFilter.endDate).add(1, 'day').startOf('day').toDate();
        let newEndDate = moment(newStartDate).endOf('year').endOf('day').toDate();

        if (moment(newEndDate).endOf('day') > moment().endOf('day')) {
            newEndDate = moment().endOf('day').toDate();
        }

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Year;

        return periodFilter;
    }
}
